import Cookie from './lib/cookies';
import getSearchMap, { mergeSearchParamsWithCurrentCookie } from './queryString';
import * as constants from './constants';
var COOKIE_MAX_AGE_IN_SECONDS = 1209600; // two weeks

var COOKIE_PATH = '/';
/**
 * Returns the current url from the window
 * @return {String}
 */

export function getURL() {
  if (window && window.location) return window.location.href;
}
/**
 * Returns the current locale from the user agent
 * @return {String}
 */

export function getLocale() {
  return navigator.languages && navigator.languages[0] || navigator.language || navigator.userLanguage;
}
/**
 * Returns the the current date as ISO
 * @return {String}
 */

export function getTimestamp() {
  return new Date().toISOString();
}
/**
 * Sets the we referrer cookie
 */

export function setReferrerCookie() {
  if (!Cookie.getItem(constants.REFERRING_DOMAIN_COOKIE_KEY)) {
    var referrer = document.referrer || '';
    Cookie.setItem(constants.REFERRING_DOMAIN_COOKIE_KEY, referrer, COOKIE_MAX_AGE_IN_SECONDS, COOKIE_PATH);
  }
}
/**
 * Sets the we referrer cookie
 */

export function setSearchParamsCookie() {
  var searchMap = getSearchMap();
  var mergedSearchMap = mergeSearchParamsWithCurrentCookie(searchMap);
  Cookie.setItem(constants.SEARCH_PARAMS_COOKIE_KEY, JSON.stringify(mergedSearchMap), COOKIE_MAX_AGE_IN_SECONDS, COOKIE_PATH);
}